module.exports = __webpack_public_path__ + "static/media/yixing.885a42dc.png";